<template>
  <component
    :is="element"
    :class="baseDisplayTextClasses"
    v-bind="$attrs"
    class="base-display-text"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<script setup>
import { computed } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "medium",
    validator: (value) => ["x-small", "small", "medium", "large", "x-large"].includes(value),
  },
  element: {
    type: String,
    default: "p",
    validator: (value) => ["h1", "h2", "h3", "h4", "h5", "h6", "p"].includes(value),
  },
});

const baseDisplayTextClasses = computed(() => ({
  [`base-display-text--size-${props.size}`]: true,
}));
</script>

<style lang="scss" scoped>
@import "./base-display-text.scss";
</style>
